import { render, staticRenderFns } from "./create-or-edit-app-detail.vue?vue&type=template&id=58bbd577&scoped=true"
import script from "./create-or-edit-app-detail.vue?vue&type=script&lang=js"
export * from "./create-or-edit-app-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bbd577",
  null
  
)

export default component.exports